import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context.js";
import { ApiError } from "../lib/api.js";
import { AccountsClosedMessage } from "../components/AccountsClosed.js";
import { useRegistrationOpen } from "../lib/site.js";
import * as s from "../styles.js";

export function LoginPage(): JSX.Element {
  const registrationOpen = useRegistrationOpen();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      const from = (location.state as { from?: { pathname: string } } | null)?.from;
      navigate(from ? from.pathname : "/", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Sign-in failed.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={s.container}>
      <h1 style={s.heading1}>Sign in</h1>
      <form onSubmit={(e) => void handleSubmit(e)} style={{ maxWidth: 360 }}>
        <label style={s.label}>
          Email
          <input style={s.input} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label style={s.label}>
          Password
          <input style={s.input} type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <p style={s.errorText}>{error}</p>}
        <button type="submit" style={s.buttonPrimary} disabled={submitting}>
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p style={{ ...s.mutedText, marginTop: 16 }}>
        <Link to="/forgot-password">Forgot your password?</Link>
      </p>
      <p style={s.mutedText}>
        No account? {registrationOpen ? <Link to="/register">Create one</Link> : <AccountsClosedMessage />}
      </p>
    </div>
  );
}
